import { eq, flow, get } from 'lodash/fp';
import { filter, map } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import { ACTIONS } from 'redux-api-call';
import { CREATE_FEATURE_API_ID } from '../apiCalls/features/create';
import { UPDATE_FEATURE_API_ID } from '../apiCalls/features/update';
import { DELETE_FEATURE_API_ID } from '../apiCalls/features/delete';
import routerHistory from '../routerHistory';
import {
  fetchFeaturesAC,
  currentPageSelector,
} from '../apiCalls/features/list';

const handleCreateFeatureSuccess = actions$ =>
  actions$.pipe(
    ofType(ACTIONS.COMPLETE),
    filter(flow(get('payload.name'), eq(CREATE_FEATURE_API_ID))),
    map(() => {
      routerHistory.push(`/emarket/features`);
    })
  );

const refreshListViewOnDelete = (action$, state$) =>
  action$.pipe(
    ofType(ACTIONS.COMPLETE),
    filter(flow(get('payload.name'), eq(DELETE_FEATURE_API_ID))),
    map(() => {
      const page = currentPageSelector(state$.value);
      return fetchFeaturesAC({ page, per_page: 12 });
    })
  );

const handleEditFeatureSuccess = actions$ =>
  actions$.pipe(
    ofType(ACTIONS.COMPLETE),
    filter(flow(get('payload.name'), eq(UPDATE_FEATURE_API_ID))),
    map(() => {
      routerHistory.push(`/emarket/features`);
    })
  );

export default combineEpics(
  handleCreateFeatureSuccess,
  refreshListViewOnDelete,
  handleEditFeatureSuccess
);
